/**
 * Retrieves the list of query parameters on the current url
 * @returns an object containing the current url parameters, or an empty object if no params
 * @example const { wid, sid } = getQSPs();
 */
export default function getQSPs() {
  const qsps = Object.create(null);

  window.location.search
    .slice(1)
    .split('&')
    .forEach((item) => {
      const [key, value = ''] = item.split('=');

      qsps[key] = value;
    });

  return qsps;
}
